$(function () {
  let t = [
    {
      label: "EU",
      name: "Europe",
      href: "https://eu.bagsmart.com/",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/eu_5b30dd26-32fb-4dc1-8c6f-c33c1ca06550.png?v=1725861162",
    },
    {
      label: "DE",
      name: "Deutschland",
      href: "https://de.bagsmart.com/",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/deflag.webp?v=1756788982",
    },
    {
      label: "FR",
      name: "France",
      href: "https://bagsmart.fr/",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/frflag.webp?v=1756788982",
    },
    {
      label: "US",
      name: "United States",
      href: "https://www.bagsmart.com",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/US.png?v=1725533397",
    },
    {
      label: "AU",
      name: "Australia",
      href: "https://au.bagsmart.com",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/australia_ccb411f2-fc06-41b6-ac1c-d0c2faf0bda6.png?v=1725861170",
    },
    {
      label: "UK",
      name: "United Kingdom",
      href: "https://uk.bagsmart.com/",
      src: "https://cdn.shopify.com/s/files/1/0719/5400/6335/files/ukupdate_ab3ca613-023a-4628-bbbc-c66ac75f6129.png?v=1725861162",
    },
  ],
    s = !1;
  $("#btn").prepend(
    `<img loading="lazy" alt="img" class="btnImg" style="margin-right: 10px" src="${t[0].src2 ?? t[0].src}"><span>${t[0].name}</span>`
  );
  for (let s of t)
    $("[data-language-selector-button-list]").append(`
      <div class="btnListItem" data-href="${s.href}">
        <img loading="lazy" alt="img" class="btnImg" style="margin-right: 10px" src="${s.src2 ?? s.src}">
        ${s.name}
      </div>
    `,
    );
  $(".btnListItem").click(function () {
    "" !== $(this).attr("data-href")
      ? (window.location.href = $(this).attr("data-href"))
      : window.location.reload();
  });
  let e =
    '<svg data-label="1" class="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n     width="19px" height="13px"><path fill-rule="evenodd"  stroke="rgb(37, 37, 37)" stroke-width="2px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"\n    d="M16.903,3.318 L9.405,10.996 L1.907,3.318 "/></svg>\n',
    l = $("[data-language-selector-button-list]"),
    a = $("#svg");
  a.html(e),
    $("#btn").click(function () {
      l.slideToggle("fast"),
        s
          ? a.html(e)
          : a.html(
            '<svg data-label="2" class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n    width="19px" height="13px"><path fill-rule="evenodd"  stroke="rgb(37, 37, 37)" stroke-width="2px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"\n   d="M16.903,3.318 L9.405,10.996 L1.907,3.318 "/></svg>\n',
          ),
        (s = !s);
    }),
    $(".e_sliderow__title").html(
      t[0].name +
      '<img loading="lazy" class="e_mobilebtnImgtop"  style="margin-left: 10px" src="' +
      t[0].src2 ?? t[0].src +
      '">',
    );
  for (let s of t)
    $(".e_selectmonilecountry").append(
      `<div class="sliderule__wrapper">\n      <div class="sliderow is-visible" data-animates="1" style="transition-delay: 60ms;">\n        <a class="sliderow__title" href="${s.href}">${s.name}<img loading="lazy" class="e_mobilebtnImg" style="margin-left: 10px" src="${s.src}"></a>\n      </div>\n    </div>`,
    );

  // Mobile header drawer
  const wrapper = document.querySelector("[data-accordion-language-selector]");
  if (wrapper) {
    const currentElement = wrapper.querySelector("[data-accordion-language-current]");
    const listElement = wrapper.querySelector("[data-accordion-language-list]");
    const $listElement = $(listElement);
    currentElement.innerHTML = `<img src="${t[0].src}">${t[0].name}`;
    listElement.innerHTML = "";
    for (const option of t) {
      $listElement.append(`
        <a href="${option.href}" class="drawer-nav__menu-head">
          <img src="${option.src}">
          ${option.name}
        </a>
      `);
    }
  }
});
